<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in filteredItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref, computed } from '@vue/composition-api'
import { getRolesFromToken } from '@/services/JwtDecoder'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const userRole = getRolesFromToken(localStorage.getItem('accessToken'))
    const filteredItems = computed(() => props.items.filter(item => {
      if (item.role) {
      // ตรวจสอบว่าบทบาทใน item เป็น array หรือไม่
        const isVisible = Array.isArray(item.role)
          ? item.role.includes(userRole[0]) // ตรวจสอบกับ userRole แรก
          : item.role === userRole[0] // ถ้าเป็น string ให้เปรียบเทียบตรงๆ

        return isVisible
      }
      return true // แสดงถ้าไม่มีการกำหนด role
    }))

    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
      filteredItems,
    }
  },
}
</script>
